(function () {
  if (window.__lumenPdp) return;
  window.__lumenPdp = true;

  var KITS = {
    "kit-stone": {
      pct: 0,
      kit: 49.95,
      eyebrow: "3-piece stone set",
      parts: [
        { name: "Dual roller (smooth + textured)", usd: 0, href: null },
        { name: "Ball roller", usd: 0, href: null },
        { name: "Matching gua sha", usd: 0, href: null }
      ],
      howTo: [
        "Warm a few drops of facial oil between your palms.",
        "Sweep the gua sha upward and outward along jaw and cheeks.",
        "Finish with the dual roller and ball roller, then wipe dry."
      ]
    },
    "kit-glow-tools": {
      pct: 10,
      kit: 36.44,
      eyebrow: "Two-tool edit",
      parts: [
        {
          name: "Ice Face Roller",
          usd: 24.49,
          href: "/products/tool-ice-roller"
        },
        {
          name: "Soft Silicone Face Brush",
          usd: 16,
          href: "/products/tool-brush"
        }
      ],
      howTo: [
        "Cleanse with the silicone brush and your favorite cleanser.",
        "Rinse, then roll the frozen ice roller across face and neck.",
        "Rinse each tool and let them dry."
      ]
    }
  };

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function onPdp() {
    return location.pathname.indexOf("/products/") !== -1;
  }

  function handle() {
    var parts = location.pathname.split("/");
    var idx = parts.indexOf("products");
    return idx >= 0 ? parts[idx + 1] || "" : "";
  }

  function money(usd) {
    if (window.LumenCurrency && window.LumenCurrency.money) {
      return window.LumenCurrency.money(usd);
    }
    try {
      var cur = (window.Shopify && Shopify.currency) || {};
      var code = cur.active || "USD";
      var rate = parseFloat(cur.rate || "1") || 1;
      var locale =
        (window.Shopify && Shopify.locale) || navigator.language || "en";
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: code
      }).format(Number(usd) * rate);
    } catch (e) {
      return "$" + Number(usd).toFixed(2);
    }
  }

  function formEl() {
    var forms = document.getElementsByTagName("form");
    for (var i = 0; i < forms.length; i++) {
      var a = forms[i].getAttribute("action") || "";
      if (a.indexOf("/cart/add") !== -1) return forms[i];
    }
    return document.querySelector(".product-form");
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function wireSteps(ol) {
    Array.prototype.forEach.call(ol.children, function (li, ix) {
      li.classList.add("lumen-howto__step");
      li.tabIndex = 0;
      if (ix === 0) li.classList.add("is-active");
      li.addEventListener("click", function () {
        Array.prototype.forEach.call(ol.children, function (s) {
          s.classList.remove("is-active");
        });
        li.classList.add("is-active");
      });
      li.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter" || ev.key === " ") {
          ev.preventDefault();
          li.click();
        }
      });
    });
  }

  function enter(node, delay) {
    if (!node) return;
    node.classList.add("lumen-enter");
    if (reduce) {
      node.classList.add("is-in");
      return;
    }
    requestAnimationFrame(function () {
      setTimeout(function () {
        node.classList.add("is-in");
      }, delay || 0);
    });
  }

  function injectKit() {
    return;
    var id = handle();
    var kit = KITS[id];
    if (!kit || document.querySelector(".lumen-kit")) return;

    var sep = 0;
    for (var i = 0; i < kit.parts.length; i++) {
      sep += Number(kit.parts[i].usd) || 0;
    }
    sep = Math.round(sep * 100) / 100;
    var save = Math.round((sep - kit.kit) * 100) / 100;

    var box = el("div", "lumen-kit");
    var eye = el("p", "lumen-kit__eyebrow", kit.eyebrow || "The set");
    var h = el("h3", "lumen-kit__title", "What's included");
    box.appendChild(eye);
    box.appendChild(h);

    var ul = el("ul", "lumen-kit__parts");
    for (var j = 0; j < kit.parts.length; j++) {
      var p = kit.parts[j];
      var li = el("li");
      var name = el("span", "lumen-kit__name");
      if (p.href) {
        var a = el("a");
        a.href = p.href;
        a.textContent = p.name;
        name.appendChild(a);
      } else {
        name.textContent = p.name;
      }
      li.appendChild(name);
      if (p.usd) {
        var price = el("span", "lumen-kit__price", money(p.usd));
        li.appendChild(price);
      }
      ul.appendChild(li);
    }
    box.appendChild(ul);

    if (kit.pct > 0) {
      var math = el("div", "lumen-kit__math");
      function row(label, value, cls) {
        var d = el("div", cls || "");
        d.appendChild(el("span", "", label));
        d.appendChild(el("strong", "", value));
        math.appendChild(d);
      }
      row("If bought separately", money(sep));
      row("Member set savings", "-" + money(save), "lumen-kit__save");
      row("Yours today", money(kit.kit), "lumen-kit__pay");
      box.appendChild(math);

      var note = el(
        "p",
        "lumen-kit__note",
        "Separate prices match each tool alone. This set is that total minus " +
          kit.pct +
          "%."
      );
      box.appendChild(note);
    } else {
      var setNote = el(
        "p",
        "lumen-kit__note",
        "Gift-ready trio — dual roller, ball roller, and gua sha in one set."
      );
      box.appendChild(setNote);
    }

    var form = formEl();
    var insertAt =
      document.querySelector(
        "variant-picker, .variant-picker, fieldset.product-form__input"
      ) || form;
    if (insertAt && insertAt.parentElement) {
      insertAt.parentElement.insertBefore(box, insertAt);
    } else if (form && form.parentElement) {
      form.parentElement.insertBefore(box, form);
    }

    enter(box, 40);

    if (kit.howTo && kit.howTo.length && !document.querySelector(".lumen-howto")) {
      var wrap = el("div", "lumen-howto");
      wrap.appendChild(el("p", "lumen-howto__eyebrow", "The ritual"));
      wrap.appendChild(el("h3", "lumen-howto__title", "How to use"));
      var ol = el("ol", "lumen-howto__steps");
      for (var s = 0; s < kit.howTo.length; s++) {
        ol.appendChild(el("li", "", kit.howTo[s]));
      }
      wireSteps(ol);
      wrap.appendChild(ol);
      box.insertAdjacentElement("afterend", wrap);
      enter(wrap, 120);
    }
  }

  function enhanceHowto() {
    return;
    if (document.querySelector(".lumen-howto")) return;
    var howtoHeading = null;
    document.querySelectorAll("h3,h2").forEach(function (h) {
      if (
        (h.textContent || "").toLowerCase().indexOf("how to use") !== -1 &&
        !h.closest(".lumen-kit")
      ) {
        howtoHeading = h;
      }
    });
    if (!howtoHeading) return;
    var ol = howtoHeading.nextElementSibling;
    while (
      ol &&
      ol.tagName !== "OL" &&
      "H1 H2 H3 H4 H5 H6".indexOf(ol.tagName) === -1
    ) {
      ol = ol.nextElementSibling;
    }
    if (!ol || ol.tagName !== "OL") return;
    var wrap = el("div", "lumen-howto");
    wrap.appendChild(el("p", "lumen-howto__eyebrow", "The ritual"));
    howtoHeading.classList.add("lumen-howto__title");
    var parent = howtoHeading.parentNode;
    wrap.appendChild(howtoHeading);
    ol.classList.add("lumen-howto__steps");
    wireSteps(ol);
    wrap.appendChild(ol);
    if (parent) parent.insertBefore(wrap, parent.firstChild);
    enter(wrap, 80);
  }

  function hideDupHowto() {
    if (!document.querySelector(".lumen-howto")) return;
    document.querySelectorAll("h2,h3").forEach(function (h) {
      if ((h.textContent || "").toLowerCase().indexOf("how to use") === -1) {
        return;
      }
      if (h.closest(".lumen-howto")) return;
      var n = h.nextElementSibling;
      h.style.display = "none";
      while (n && n.tagName !== "H2" && n.tagName !== "H3") {
        var nx = n.nextElementSibling;
        if (n.tagName === "OL" || n.tagName === "UL") n.style.display = "none";
        n = nx;
      }
    });
  }

  function injectBuyTrust() {
    return;
    if (document.querySelector(".lumen-buy-trust")) return;
    var form = formEl() || document.querySelector(".buy-buttons");
    if (!form) return;
    var host =
      form.closest(
        ".product-information__buy-buttons, .buy-buttons, .product-form"
      ) ||
      form.parentElement ||
      form;

    var shopPay = document.querySelector(
      "shop-pay-wallet-button, .shopify-payment-button, shopify-accelerated-checkout, [data-shopify-buttoncontainer]"
    );
    if (shopPay && !document.querySelector(".lumen-express-label")) {
      var lab = el(
        "p",
        "lumen-express-label",
        "Express checkout - Shop Pay / Apple Pay / Google Pay"
      );
      if (shopPay.parentElement) {
        shopPay.parentElement.insertBefore(lab, shopPay);
      }
    }

    var trust = el("ul", "lumen-buy-trust");
    var items = [
      ["14-day money-back", "Unused items, original payment method"],
      [
        "UK, USA, Australia & Canada",
        "Standard " + money(6.95) + " · pack 1–2 business days · 10–25 days to arrive"
      ],
      ["Secure checkout", "Shop Pay, cards, Apple Pay"],
      ["Real support", "Questions answered by a real person"]
    ];
    for (var i = 0; i < items.length; i++) {
      var li = el("li");
      li.appendChild(el("strong", "", items[i][0]));
      li.appendChild(el("span", "", items[i][1]));
      trust.appendChild(li);
    }
    host.appendChild(trust);
    enter(trust, 160);
  }

  /* One-line value proposition, sitting directly under the price. */
  var PITCH = {
    "tool-led":
      "Seven colour modes, worn hands-free — a full LED session without holding anything.",
    "tool-gua":
      "Heat and vibration add an extra dimension to your facial massage routine.",
    "tool-ice-roller":
      "Freeze it once, then roll cool relief across face, eyes and neck — ideal for refreshing mornings or winding down.",
    "kit-stone":
      "Three classic stone tools — gua sha, dual roller and ball roller — in one gift-ready set.",
    "kit-glow-tools":
      "A two-tool starter edit: cleanse with the silicone brush, then cool down with the ice roller."
  };

  /** Honest value prop + risk reversal — no fake review counts */
  function injectSalesProof() {
    return;
    if (document.querySelector(".lumen-sales-proof")) return;
    var price =
      document.querySelector(
        ".lumen-pdp-price, .price, .product__price, .price-item__group"
      ) || document.querySelector("h1");
    if (!price || !price.parentElement) return;

    var proof = el("div", "lumen-sales-proof");
    proof.appendChild(
      el(
        "p",
        "lumen-sales-proof__line",
        PITCH[handle()] || "An at-home beauty tool with a simple three-step routine."
      )
    );
    proof.appendChild(
      el(
        "p",
        "lumen-sales-proof__sub",
        "14-day money-back on unused items · UK, USA, Australia and Canada · Secure checkout"
      )
    );
    if (price.nextSibling) {
      price.parentElement.insertBefore(proof, price.nextSibling);
    } else {
      price.parentElement.appendChild(proof);
    }
    enter(proof, 80);
  }

  function injectGuarantee() {
    return;
    if (document.querySelector(".lumen-guarantee")) return;
    var submit = document.querySelector(
      "button[name='add'], .product-form__submit, .buy-buttons button[type='submit']"
    );
    if (!submit) return;
    var host =
      submit.closest(
        ".product-information__buy-buttons, .buy-buttons, .product-form, product-form"
      ) || submit.parentElement;
    if (!host) return;
    var g = el("p", "lumen-guarantee");
    g.innerHTML =
      "<strong>14-day money-back</strong> on unused items. Refund to your original payment method.";
    if (submit.nextSibling) host.insertBefore(g, submit.nextSibling);
    else host.appendChild(g);
    enter(g, 120);
  }

  /* Handles only — titles/prices/images load live from /products/{handle}.json */
  var RITUALS = {
    "tool-led": ["tool-eye-wand", "tool-brush"],
    "tool-gua": ["kit-stone", "tool-ice-roller"],
    "tool-ice-roller": ["tool-brush", "kit-glow-tools"],
    "tool-brush": ["tool-ice-roller", "kit-glow-tools"],
    "tool-eye-wand": ["tool-led", "tool-gua"],
    "kit-glow-tools": ["kit-stone", "tool-led"],
    "kit-stone": ["kit-glow-tools", "tool-gua"],
    "tool-ice-globes": ["tool-gua", "tool-ice-roller"],
    "tool-pore": ["tool-brush", "tool-steamer"],
    "tool-steamer": ["tool-brush", "tool-pore"],
    "tool-scalp-comb": ["tool-scalp", "kit-stone"],
    "tool-mirror": ["tool-lash", "tool-brow"],
    "tool-lash": ["tool-brow", "tool-mirror"],
    "tool-brow": ["tool-lash", "tool-mirror"]
  };

  function fetchProductJson(handleName, cb) {
    fetch("/products/" + handleName + ".json", {
      credentials: "same-origin"
    })
      .then(function (r) {
        if (!r.ok) throw new Error("missing");
        return r.json();
      })
      .then(function (data) {
        cb(null, data && data.product);
      })
      .catch(function () {
        cb(true);
      });
  }

  function addVariantToCart(variantId, btn) {
    if (!variantId || !btn || btn.dataset.busy === "1") return;
    btn.dataset.busy = "1";
    var prev = btn.textContent;
    btn.textContent = "Adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("cart");
        return r.json();
      })
      .then(function () {
        btn.textContent = "Added ✓";
        btn.classList.add("is-added");
        try {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } catch (e) {}
        try {
          fetch("/cart.js")
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              document.dispatchEvent(
                new CustomEvent("cart:updated", { detail: cart })
              );
            });
        } catch (e2) {}
        setTimeout(function () {
          btn.textContent = prev;
          btn.dataset.busy = "0";
          btn.classList.remove("is-added");
        }, 1600);
      })
      .catch(function () {
        btn.textContent = "Try again";
        btn.dataset.busy = "0";
        setTimeout(function () {
          btn.textContent = prev;
        }, 1200);
      });
  }

  function injectCompleteRitual() {
    return;
    if (document.querySelector(".lumen-ritual")) return;
    var handles = RITUALS[handle()];
    if (!handles || !handles.length) return;
    var trust = document.querySelector(".lumen-buy-trust");
    var host =
      (trust && trust.parentElement) ||
      document.querySelector(
        ".product-information, .product__info-container, product-info"
      );
    if (!host) return;

    var box = el("div", "lumen-ritual");
    box.appendChild(el("p", "lumen-ritual__eyebrow", "Complete your ritual"));
    box.appendChild(el("h3", "lumen-ritual__title", "Add the matching tools"));
    var list = el("ul", "lumen-ritual__list");
    box.appendChild(list);
    if (trust && trust.nextSibling) host.insertBefore(box, trust.nextSibling);
    else host.appendChild(box);
    enter(box, 200);

    handles.forEach(function (h) {
      fetchProductJson(h, function (err, product) {
        if (err || !product || !product.variants || !product.variants.length) {
          return;
        }
        var variant = product.variants[0];
        var imgSrc =
          (product.images && product.images[0] && product.images[0].src) ||
          (product.image && product.image.src) ||
          "";
        // Only that product's own hero — never swap images across products
        var li = el("li", "lumen-ritual__item");
        if (imgSrc) {
          var img = document.createElement("img");
          img.className = "lumen-ritual__thumb";
          img.src = imgSrc + (imgSrc.indexOf("?") === -1 ? "?" : "&") + "width=160";
          img.alt = product.title || "";
          img.width = 56;
          img.height = 56;
          img.loading = "lazy";
          li.appendChild(img);
        }
        var meta = el("div", "lumen-ritual__meta");
        var link = el("a", "lumen-ritual__name", product.title);
        link.href = "/products/" + product.handle;
        meta.appendChild(link);
        meta.appendChild(
          el("span", "lumen-ritual__price", money(Number(variant.price)))
        );
        li.appendChild(meta);
        var btn = el("button", "lumen-ritual__add", "Add");
        btn.type = "button";
        btn.setAttribute("aria-label", "Add " + product.title + " to cart");
        btn.addEventListener("click", function (ev) {
          ev.preventDefault();
          addVariantToCart(variant.id, btn);
        });
        li.appendChild(btn);
        list.appendChild(li);
      });
    });
  }

  function polishBuyBox() {
    var submit = document.querySelector(
      "button[name='add'], .product-form__submit, .buy-buttons button[type='submit']"
    );
    if (submit) submit.classList.add("lumen-cta", "lumen-cta--primary");

    var title = document.querySelector(
      "h1.product__title, .product__title, .product-title, h1"
    );
    if (title) title.classList.add("lumen-pdp-title");

    var price = document.querySelector(
      ".price, .product__price, .price-item__group"
    );
    if (price) price.classList.add("lumen-pdp-price");
  }

  function isShopifyImg(url) {
    return (
      !!url &&
      (url.indexOf("cdn.shopify.com") !== -1 ||
        url.indexOf("/cdn/shop/") !== -1)
    );
  }

  function stripSizeParams(url) {
    var clean = String(url || "").split(" ")[0];
    clean = clean
      .replace(/([?&])width=\d+/g, "")
      .replace(/([?&])height=\d+/g, "")
      .replace(/\?&/, "?")
      .replace(/&&/g, "&")
      .replace(/[?&]$/, "");
    return clean;
  }

  function hiResUrl(url, w) {
    if (!isShopifyImg(url)) return url;
    w = w || 2048;
    var clean = stripSizeParams(url);
    return clean + (clean.indexOf("?") === -1 ? "?" : "&") + "width=" + w;
  }

  function readWidth(url) {
    var m = String(url || "").match(/[?&]width=(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  /** Active slide: max crisp. Others: capped so scroll/swap stays 0-lag. */
  function sharpenImages(root) {
    var host = root || document;
    var dpr = window.devicePixelRatio || 1;
    var gallery = host.closest
      ? host.closest("media-gallery") || host.querySelector("media-gallery")
      : document.querySelector("media-gallery");
    var activeIx = gallery ? getIx(gallery) : 0;
    var imgs = host.querySelectorAll
      ? host.querySelectorAll("media-gallery img, .product-media img")
      : [];
    for (var i = 0; i < imgs.length; i++) {
      (function (img, ix) {
        var src = img.currentSrc || img.getAttribute("src") || "";
        if (!isShopifyImg(src)) return;
        var slide = img.closest("slideshow-slide");
        var slides = gallery ? slidesOf(gallery) : [];
        var slideIx = -1;
        for (var s = 0; s < slides.length; s++) {
          if (slides[s] === slide) {
            slideIx = s;
            break;
          }
        }
        var active = slideIx === activeIx || slideIx < 0;
        var near =
          slideIx >= 0 &&
          (slideIx === activeIx ||
            slideIx === (activeIx + 1) % Math.max(slides.length, 1) ||
            slideIx === (activeIx - 1 + slides.length) % Math.max(slides.length, 1));
        var want = active
          ? Math.min(
              2000,
              Math.max(1400, Math.ceil((img.clientWidth || 600) * dpr * 2))
            )
          : near
            ? 1200
            : 900;
        if (img.dataset.lumenHi === String(want)) return;

        img.loading = active || near ? "eager" : "lazy";
        img.decoding = "async";
        if (active) {
          try {
            img.fetchPriority = "high";
          } catch (e) {}
        }
        img.removeAttribute("srcset");
        img.sizes =
          Math.ceil((img.clientWidth || window.innerWidth * 0.5) * dpr) + "px";

        var next = hiResUrl(src, want);
        if (readWidth(src) === want) {
          img.dataset.lumenHi = String(want);
          return;
        }
        var pre = new Image();
        pre.decoding = "async";
        pre.onload = function () {
          if (img.getAttribute("src") !== next) img.setAttribute("src", next);
          img.dataset.lumenHi = String(want);
        };
        pre.onerror = function () {
          img.dataset.lumenHi = String(want);
        };
        pre.src = next;
      })(imgs[i], i);
    }
  }

  function slideshowEl(gallery) {
    var sc = gallery.querySelector("slideshow-component");
    if (sc) return sc;
    var slides = gallery.querySelector("slideshow-slides");
    return slides && slides.closest
      ? slides.closest("slideshow-component")
      : null;
  }

  function slidesOf(gallery) {
    var scope = (gallery && gallery.querySelector("slideshow-slides")) || gallery;
    if (!scope) return [];
    var all = scope.querySelectorAll("slideshow-slide");
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var img = all[i].querySelector("img");
      if (!img) continue;
      var src =
        img.getAttribute("src") ||
        img.getAttribute("srcset") ||
        img.currentSrc ||
        "";
      if (!src) continue;
      out.push(all[i]);
    }
    return out;
  }

  function slideCount(gallery) {
    return slidesOf(gallery).length;
  }

  function getIx(gallery) {
    var n = slideCount(gallery);
    var ix = parseInt(gallery.dataset.lumenIx || "0", 10);
    if (!n) return 0;
    if (isNaN(ix) || ix < 0 || ix >= n) return 0;
    return ix;
  }

  /** Valrella owns which slide is visible — theme leaves several aria-hidden=false. */
  function showIx(gallery, ix, fromGuard) {
    if (fromGuard && gallery.dataset.lumenSyncing === "1") return;
    var slides = slidesOf(gallery);
    var n = slides.length;
    if (!n) return;
    ix = ((ix % n) + n) % n;
    gallery.dataset.lumenSyncing = "1";
    gallery.dataset.lumenIx = String(ix);
    try {
      var scope = gallery.querySelector("slideshow-slides") || gallery;
      var all = scope.querySelectorAll("slideshow-slide");
      for (var j = 0; j < all.length; j++) {
        var on = all[j] === slides[ix];
        all[j].classList.toggle("lumen-slide-active", on);
        all[j].setAttribute("aria-hidden", on ? "false" : "true");
        all[j].toggleAttribute("hidden", !on);
        all[j].style.setProperty("display", on ? "flex" : "none", "important");
        all[j].style.setProperty("opacity", on ? "1" : "0", "important");
        all[j].style.setProperty("visibility", on ? "visible" : "hidden", "important");
        all[j].style.setProperty("z-index", on ? "2" : "0", "important");
        all[j].style.setProperty("pointer-events", "none", "important");
      }

      var dots = gallery.querySelectorAll(".lumen-dots button");
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute("aria-current", d === ix ? "true" : "false");
      }
    } finally {
      setTimeout(function () {
        gallery.dataset.lumenSyncing = "0";
      }, 80);
    }
  }

  function syncActiveSlide(gallery) {
    showIx(gallery, getIx(gallery));
  }

  function goSlide(gallery, dir) {
    var y = window.scrollY;
    showIx(gallery, getIx(gallery) + dir);
    killZoom(gallery);
    forceCover(gallery);
    sharpenImages(gallery);
    requestAnimationFrame(function () {
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
    });
  }

  /** Clicking the product photo must not jump/scroll the page. */
  function stopGalleryClickScroll() {
    if (document.documentElement.dataset.lumenNoPdpScroll === "1") return;
    document.documentElement.dataset.lumenNoPdpScroll = "1";
    function lockY(ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (!t.closest("media-gallery, .lumen-arrows, slideshow-component, slideshow-slide, .product-media-container")) {
        return;
      }
      var y = window.scrollY || window.pageYOffset || 0;
      requestAnimationFrame(function () {
        if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
      });
      setTimeout(function () {
        if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
      }, 0);
      setTimeout(function () {
        if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
      }, 80);
      setTimeout(function () {
        if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
      }, 200);
    }
    document.addEventListener("click", lockY, true);
    document.addEventListener("mousedown", lockY, true);
    document.addEventListener("pointerdown", lockY, true);
    document.addEventListener(
      "focusin",
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (!t.closest("media-gallery, .lumen-arrows, slideshow-component")) return;
        var y = window.scrollY || 0;
        requestAnimationFrame(function () {
          window.scrollTo(0, y);
        });
      },
      true
    );
  }

  function hideThemeArrows(gallery) {
    var root = gallery.closest("media-gallery") || gallery;
    var nodes = root.querySelectorAll(
      "slideshow-arrows, slideshow-controls, .slideshow-control, .slideshow-controls__counter, .slideshow-controls__dots, .media-gallery__mobile-controls"
    );
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.setProperty("display", "none", "important");
      nodes[i].style.setProperty("pointer-events", "none", "important");
      nodes[i].setAttribute("aria-hidden", "true");
    }
    var extras = document.querySelectorAll(
      "media-gallery slideshow-controls, media-gallery .slideshow-controls__dots, media-gallery .slideshow-control"
    );
    for (var j = 0; j < extras.length; j++) {
      extras[j].style.setProperty("display", "none", "important");
      extras[j].setAttribute("aria-hidden", "true");
    }
  }

  function chevron(dir) {
    var svg = dir < 0
      ? '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M12.5 4.5 7 10l5.5 5.5"/></svg>'
      : '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M7.5 4.5 13 10l-5.5 5.5"/></svg>';
    return svg;
  }

  function mountArrows(gallery) {
    var n = slideCount(gallery);
    var existing = gallery.querySelector(".lumen-arrows");
    if (existing && existing.parentElement !== gallery) {
      existing.remove();
      existing = null;
    }
    if (n < 2) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    var host = gallery;
    if (getComputedStyle(host).position === "static") {
      host.style.setProperty("position", "relative", "important");
    }

    var wrap = el("div", "lumen-arrows");
    var prev = el("button", "lumen-arrows__btn lumen-arrows__btn--prev");
    prev.type = "button";
    prev.setAttribute("aria-label", "Previous image");
    prev.innerHTML = chevron(-1);
    var next = el("button", "lumen-arrows__btn lumen-arrows__btn--next");
    next.type = "button";
    next.setAttribute("aria-label", "Next image");
    next.innerHTML = chevron(1);

    function wire(btn, dir) {
      btn.addEventListener(
        "click",
        function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
          goSlide(gallery, dir);
        },
        true
      );
    }
    wire(prev, -1);
    wire(next, 1);
    wrap.appendChild(prev);
    wrap.appendChild(next);
    host.appendChild(wrap);
  }

  function bindSwipe(gallery) {
    if (gallery.dataset.lumenSwipe === "1") return;
    gallery.dataset.lumenSwipe = "1";
    var host = gallery.querySelector("slideshow-slides") || gallery;
    var x0 = 0;
    var y0 = 0;
    var t0 = 0;
    host.addEventListener(
      "touchstart",
      function (ev) {
        if (!ev.touches || !ev.touches[0]) return;
        x0 = ev.touches[0].clientX;
        y0 = ev.touches[0].clientY;
        t0 = Date.now();
      },
      { passive: true }
    );
    host.addEventListener(
      "touchend",
      function (ev) {
        if (!ev.changedTouches || !ev.changedTouches[0]) return;
        var dx = ev.changedTouches[0].clientX - x0;
        var dy = ev.changedTouches[0].clientY - y0;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (Date.now() - t0 > 800) return;
        goSlide(gallery, dx < 0 ? 1 : -1);
      },
      { passive: true }
    );
  }

  function guardGallery(gallery) {
    if (gallery.dataset.lumenGuard === "1") return;
    gallery.dataset.lumenGuard = "1";
    var timer = null;
    var host = gallery.querySelector("slideshow-slides") || gallery;
    var obs = new MutationObserver(function () {
      if (gallery.dataset.lumenSyncing === "1") return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        showIx(gallery, getIx(gallery), true);
      }, 20);
    });
    obs.observe(host, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["aria-hidden", "class", "style", "hidden"]
    });
  }

  function bindKeys() {
    if (document.documentElement.dataset.lumenKeys === "1") return;
    document.documentElement.dataset.lumenKeys = "1";
    document.addEventListener("keydown", function (ev) {
      if (!document.documentElement.classList.contains("lumen-pdp")) return;
      var tag = ((ev.target && ev.target.tagName) || "").toUpperCase();
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return;
      var gallery = document.querySelector("media-gallery");
      if (!gallery || slideCount(gallery) < 2) return;
      if (ev.key === "ArrowLeft") {
        ev.preventDefault();
        goSlide(gallery, -1);
      } else if (ev.key === "ArrowRight") {
        ev.preventDefault();
        goSlide(gallery, 1);
      }
    });
  }

  function killZoom(gallery) {
    var zooms = gallery.querySelectorAll(
      ".product-media-container__zoom-button, button[aria-label*='Zoom'], button[aria-haspopup='dialog']"
    );
    for (var i = 0; i < zooms.length; i++) {
      zooms[i].style.setProperty("display", "none", "important");
      zooms[i].style.setProperty("pointer-events", "none", "important");
      zooms[i].setAttribute("tabindex", "-1");
      zooms[i].setAttribute("aria-hidden", "true");
    }
    gallery.querySelectorAll("a[href*='zoom'], .product-media-container--zoomable").forEach(
      function (n) {
        n.classList.remove("product-media-container--zoomable");
      }
    );
  }

  function forceCover(gallery) {
    var nodes = gallery.querySelectorAll(
      ".media-fit-cover, .constrain-height, .product-media-container"
    );
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.remove("media-fit-cover", "constrain-height");
      nodes[i].classList.add("media-fit-contain");
    }
    var imgs = gallery.querySelectorAll("img");
    for (var j = 0; j < imgs.length; j++) {
      imgs[j].style.setProperty("object-fit", "cover", "important");
      imgs[j].style.setProperty("width", "100%", "important");
      imgs[j].style.setProperty("height", "100%", "important");
      imgs[j].style.setProperty("opacity", "1", "important");
      imgs[j].style.setProperty("filter", "none", "important");
      imgs[j].style.removeProperty("max-height");
    }
  }

  var SWATCH = {
    champagne: "#e6d3b3",
    "blush pink": "#e8a0b0",
    black: "#1a1a1a",
    "sky blue": "#7eb8d8",
    mint: "#8fd4b8",
    silver: "#c5c7cb",
    olive: "#6b7a3d",
    "hot pink": "#e23d7a",
    navy: "#1b2a4a",
    pink: "#e89bb5",
    purple: "#7b5ea7",
    blue: "#4a7cbc",
    nude: "#d4b39a",
    green: "#4d8f62",
    "dark green": "#2f5c3f",
    white: "#f4f1ea",
    "rose quartz": "#d9a3b0",
    "rose gold": "#c48b6c"
  };

  function paintSwatches() {
    var inputs = document.querySelectorAll(
      ".variant-option input[data-option-name]"
    );
    var selected = "";
    for (var i = 0; i < inputs.length; i++) {
      var name = (inputs[i].getAttribute("data-option-name") || "").toLowerCase();
      if (name !== "colour" && name !== "color") continue;
      var value = (inputs[i].value || "").trim();
      var hex = SWATCH[value.toLowerCase()];
      if (!hex) continue;
      var label = inputs[i].closest("label");
      if (!label) continue;
      label.style.setProperty("--lumen-swatch", hex);
      label.classList.add("lumen-has-swatch");
      if (
        ["champagne", "silver", "white", "nude", "mint", "sky blue"].indexOf(
          value.toLowerCase()
        ) !== -1
      ) {
        label.classList.add("lumen-swatch-light");
      }
      if (!label.querySelector(".variant-option__button-label__pill")) {
        var pill = document.createElement("span");
        pill.className = "variant-option__button-label__pill";
        pill.setAttribute("aria-hidden", "true");
        var text = label.querySelector(".variant-option__button-label__text");
        if (text) label.insertBefore(pill, text);
        else label.appendChild(pill);
      }
      if (inputs[i].checked) selected = value;
    }
    if (!selected) return;
    var field = document.querySelector(
      'fieldset.variant-option:has(input[data-option-name="Colour"]), fieldset.variant-option:has(input[data-option-name="Color"])'
    );
    if (!field) return;
    var legend = field.querySelector("legend");
    if (legend) legend.textContent = "Colour · " + selected;
  }

  function imgKey(url) {
    var m = String(url || "").match(/\/([^/?]+\.(?:jpe?g|png|webp))/i);
    return m ? m[1].toLowerCase() : "";
  }

  function bareKey(name) {
    return String(name || "")
      .toLowerCase()
      .replace(/_[a-f0-9]{8,}(?:-[a-f0-9]{4,})+/g, "")
      .replace(/_(?:large|grande|master|1024x1024).*/, "");
  }

  function keysMatch(a, b) {
    if (!a || !b) return false;
    if (a === b) return true;
    return bareKey(a) === bareKey(b);
  }

  function colorSlugs(name) {
    var s = String(name || "").toLowerCase().trim();
    if (!s || s === "default title") return [];
    return [s.replace(/\s+/g, "-"), s.replace(/\s+/g, "")];
  }

  function slideHasFile(slide, want, slugs) {
    if (!slide) return false;
    var img = slide.querySelector("img");
    if (!img) return false;
    var hay = (
      (img.currentSrc || "") +
      " " +
      (img.getAttribute("src") || "") +
      " " +
      (img.getAttribute("srcset") || "")
    ).toLowerCase();
    var key = imgKey(img.currentSrc || img.getAttribute("src") || "");
    if (want && (keysMatch(key, want) || hay.indexOf(want) !== -1)) return true;
    for (var i = 0; i < slugs.length; i++) {
      var slug = slugs[i];
      if (slug.length < 3) continue;
      if (hay.indexOf("-" + slug + ".") !== -1 || hay.indexOf("-" + slug + "-") !== -1) {
        return true;
      }
    }
    return false;
  }

  function selectedVariant(product) {
    var checked = document.querySelector(
      ".variant-option input:checked, .variant-option input[data-current-checked='true']"
    );
    var id = "";
    if (checked) id = checked.getAttribute("data-variant-id") || "";
    if (!id) {
      var form = formEl();
      var hid = (form && form.querySelector('input[name="id"]')) ||
        document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
      if (hid) id = hid.value || "";
    }
    var variants = (product && product.variants) || [];
    var i;
    for (i = 0; i < variants.length; i++) {
      if (id && String(variants[i].id) === String(id)) return variants[i];
    }
    if (checked) {
      var val = (checked.value || "").toLowerCase().trim();
      for (i = 0; i < variants.length; i++) {
        var title = (variants[i].title || variants[i].option1 || "").toLowerCase().trim();
        if (title === val) return variants[i];
      }
    }
    return variants[0] || null;
  }

  function loadProduct(cb) {
    if (window.__lumenProduct) {
      cb(window.__lumenProduct);
      return;
    }
    if (!window.__lumenProductWait) window.__lumenProductWait = [];
    window.__lumenProductWait.push(cb);
    if (window.__lumenProductWait.length > 1) return;
    fetch("/products/" + handle() + ".js")
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        window.__lumenProduct = p;
        var q = window.__lumenProductWait || [];
        window.__lumenProductWait = null;
        for (var i = 0; i < q.length; i++) q[i](p);
      })
      .catch(function () {
        window.__lumenProductWait = null;
      });
  }

  function applyVariantImage(gallery) {
    if (!gallery) gallery = document.querySelector("media-gallery");
    if (!gallery) return;
    loadProduct(function (product) {
      var variant = selectedVariant(product);
      if (!variant) return;
      var fi = variant.featured_image;
      var url = fi && fi.src ? fi.src : "";
      var want = imgKey(url);
      var slugs = colorSlugs(variant.option1 || variant.title);
      var slides = slidesOf(gallery);
      var found = -1;
      var s;
      for (s = 0; s < slides.length; s++) {
        if (slideHasFile(slides[s], want, slugs)) {
          found = s;
          break;
        }
      }
      if (found < 0 && url) {
        for (s = 0; s < slides.length; s++) {
          var key = imgKey(
            (slides[s].querySelector("img") || {}).currentSrc ||
              ((slides[s].querySelector("img") || {}).getAttribute &&
                slides[s].querySelector("img").getAttribute("src")) ||
              ""
          );
          if (key && /howto|how-to|modes|colours|colors/.test(key)) continue;
          var hero = slides[s].querySelector("img");
          if (!hero) continue;
          hero.removeAttribute("srcset");
          hero.src = url;
          hero.dataset.lumenHi = "";
          found = s;
          break;
        }
      }
      if (found < 0) return;
      showIx(gallery, found);
      killZoom(gallery);
      forceCover(gallery);
      sharpenImages(gallery);
    });
  }

  function bindVariantClicks(gallery) {
    if (document.documentElement.dataset.lumenVariant === "1") return;
    document.documentElement.dataset.lumenVariant = "1";
    function go() {
      var g = document.querySelector("media-gallery") || gallery;
      applyVariantImage(g);
      paintSwatches();
    }
    function onPicker(ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (
        !t.closest(
          "variant-picker, .variant-picker, .variant-option, fieldset.product-form__input, .product-form__input"
        )
      ) {
        return;
      }
      setTimeout(go, 30);
      setTimeout(go, 160);
    }
    document.addEventListener("change", onPicker, true);
    document.addEventListener("click", onPicker, true);
    document.addEventListener("variant:change", go);
    document.addEventListener("variant:update", go);
  }

  function mountDots(gallery) {
    var n = slideCount(gallery);
    var existing = gallery.querySelector(".lumen-dots");
    if (n < 2) {
      if (existing) existing.remove();
      return;
    }
    if (existing && existing.children.length === n) return;
    if (existing) existing.remove();
    var wrap = el("div", "lumen-dots");
    wrap.setAttribute("role", "tablist");
    wrap.setAttribute("aria-label", "Product photos");
    var ix = getIx(gallery);
    for (var i = 0; i < n; i++) {
      var btn = el("button", "");
      btn.type = "button";
      btn.setAttribute("aria-label", "Photo " + (i + 1) + " of " + n);
      if (i === ix) btn.setAttribute("aria-current", "true");
      (function (slot) {
        btn.addEventListener("click", function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          showIx(gallery, slot);
        });
      })(i);
      wrap.appendChild(btn);
    }
    gallery.appendChild(wrap);
  }

  /** Hide duplicate thumbnail grid + lock carousel + arrows. */
  function tidyGallery() {
    var gallery = document.querySelector("media-gallery");
    if (!gallery) return;
    gallery.classList.remove("media-gallery--grid", "media-gallery--two-column", "media-gallery--two");
    gallery.setAttribute("data-presentation", "carousel");
    gallery.style.setProperty("overflow", "visible", "important");
    gallery.style.setProperty("position", "relative", "important");

    var slidesWrap = gallery.querySelector("slideshow-slides");
    if (slidesWrap) {
      slidesWrap.style.setProperty("overflow", "hidden", "important");
      slidesWrap.style.setProperty("position", "relative", "important");
    }

    if (gallery.dataset.lumenIx == null) gallery.dataset.lumenIx = "0";

    killZoom(gallery);
    hideThemeArrows(gallery);
    forceCover(gallery);
    showIx(gallery, getIx(gallery));
    mountArrows(gallery);
    mountDots(gallery);
    bindSwipe(gallery);
    guardGallery(gallery);
    bindKeys();
    paintSwatches();
    sharpenImages(gallery);

    bindVariantClicks(gallery);

    if (gallery.dataset.lumenWired === "1") return;
    gallery.dataset.lumenWired = "1";

    loadProduct(function () {
      applyVariantImage(gallery);
    });
  }

  function oilHint() {
    return;
    if (handle() !== "tool-gua") return;
    if (document.querySelector(".lumen-oil-hint")) return;
    var opts =
      document.querySelector(
        ".variant-picker, fieldset.product-form__input, .product-form__input"
      ) || formEl();
    if (!opts) return;
    var hint = el(
      "p",
      "lumen-oil-hint",
      "Both sets include the same device and comb-style accessory. Device + 3 oils adds two extra massage oils for " +
        money(2) +
        "."
    );
    opts.appendChild(hint);
    enter(hint, 100);
  }

  function refreshFxCopy() {
    if (!onPdp()) return;
    var trust = document.querySelector(".lumen-buy-trust");
    if (trust) trust.remove();
    var oil = document.querySelector(".lumen-oil-hint");
    if (oil) oil.remove();
    var howto = document.querySelector(".lumen-howto");
    if (howto) howto.remove();
    var kit = document.querySelector(".lumen-kit");
    if (kit) kit.remove();
    var proof = document.querySelector(".lumen-sales-proof");
    if (proof) proof.remove();
    var g = document.querySelector(".lumen-guarantee");
    if (g) g.remove();
    var ritual = document.querySelector(".lumen-ritual");
    if (ritual) ritual.remove();
    injectKit();
    oilHint();
    injectSalesProof();
    injectBuyTrust();
    injectGuarantee();
    injectCompleteRitual();
  }

  function bootWhenReady() {
    if (!onPdp()) return;
    document.documentElement.classList.add("lumen-pdp");
    var drops = document.querySelector(".lumen-drops");
    if (drops) drops.remove();
    stopGalleryClickScroll();
    polishBuyBox();
    tidyGallery();
    setTimeout(tidyGallery, 300);
    setTimeout(tidyGallery, 900);
    injectKit();
    enhanceHowto();
    hideDupHowto();
    oilHint();
    injectSalesProof();
    injectBuyTrust();
    injectGuarantee();
    injectCompleteRitual();
    if (window.LumenCurrency && window.LumenCurrency.refresh) {
      window.LumenCurrency.refresh();
    }
  }

  document.addEventListener("lumen:fx", refreshFxCopy);
  document.addEventListener("shopify:section:load", tidyGallery);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootWhenReady, { once: true });
  } else {
    bootWhenReady();
  }
})();
